import { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Flex, Box, Button } from "@chakra-ui/react";
import { compose } from "recompose";
import * as selectors from "src/modules/avatar/duck/selectors";
import { setDefaultAvatar } from "src/modules/avatar/duck/actions";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import LoadableContent from "src/components/LoadableContent";
import SvgContainer from "src/components/SvgContainer";
import { H2 } from "src/atoms/typography";
import AvatarPicker from "./AvatarPicker";
import { FamilyName, Card } from "./styles";
import { ReactComponent as FamilyIcon } from "./family.svg";

class StationCard extends Component {
  state = {
    selectedAvatarId: this.getInitialAvatarId()
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { station } = this.props;
    if (
      station.avatarId !== prevProps.station.avatarId &&
      station.group === "myDevices"
    ) {
      this.setState({ selectedAvatarId: station.avatarId });
    }
  };

  getInitialAvatarId() {
    const { avatars, defaultAvatarId, station } = this.props;
    if (
      station.avatarId &&
      avatars[station.avatarId] &&
      avatars[station.avatarId].deleted === false
    ) {
      return station.avatarId;
    } else return defaultAvatarId;
  }

  handleAvatarChange = (avatarId) => {
    this.props.dispatch(setDefaultAvatar(avatarId));
    this.setState({ selectedAvatarId: avatarId });
  };
  handleConnect(station) {
    const { selectedAvatarId } = this.state;
    const { onConnect, defaultAvatarId } = this.props;
    const isFamilyDevice = station.group === "myDevices";

    if (isFamilyDevice && selectedAvatarId !== defaultAvatarId) {
      this.props.dispatch(setDefaultAvatar(selectedAvatarId));
    }
    onConnect([{ ...station, avatarId: selectedAvatarId }]);
  }

  render() {
    const { selectedAvatarId } = this.state;
    const { t, station, isConnecting, myFamilyName, avatars, isInModal } =
      this.props;
    const isFamilyDevice = station?.group === "myDevices";
    const familyName = isFamilyDevice ? myFamilyName : station?.familyName;

    return (
      <Card bg={isInModal ? "surfaceElevated2" : "surfaceElevated1"}>
        <Flex
          flexGrow={1}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <Flex
            flexDirection="column"
            alignItems="center"
            width="100%"
            mb={station.familyName ? "24px" : "16px"}
          >
            <Box mb={["4px", "10px", "12px"]}>
              <CorrespondingAvatar
                avatar={isFamilyDevice ? avatars[selectedAvatarId] : undefined}
                width={[
                  "64px !important",
                  "90px !important",
                  "102px !important"
                ]}
                height={[
                  "64px !important",
                  "90px !important",
                  "102px !important"
                ]}
              />
            </Box>
            {isFamilyDevice && (
              <AvatarPicker
                selectedAvatarId={selectedAvatarId}
                avatars={avatars}
                handleAvatarChange={this.handleAvatarChange}
              />
            )}
          </Flex>
          {!isFamilyDevice && familyName && (
            <Flex mb="8px" justifyContent="center" alignItems="center">
              <SvgContainer
                fill="lowEmphasis"
                size="16px"
                mr="8px"
                icon={FamilyIcon}
              />
              <FamilyName>{familyName}</FamilyName>
            </Flex>
          )}
          <H2
            color="highEmphasis"
            textAlign="center"
            width="100%"
            display="-webkit-box"
            overflow="hidden"
            textOverflow="ellipsis"
            wordBreak="break-word"
            fontSize={["2rem", "2.8rem", "3.2rem"]}
            sx={{
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical"
            }}
          >
            {station.name}
          </H2>
        </Flex>
        <LoadableContent showContent={!isConnecting}>
          <Flex flexShrink={0} alignItems="center" flexDirection="column">
            <Button
              variant="containedPrimary"
              fontSize={["1.2rem", "1.7rem", "1.8rem"]}
              px={["24px", "40px", "46px"]}
              py={["11px", "17px", "19px"]}
              borderRadius={["18px", "28px", "36px"]}
              onClick={() => this.handleConnect(station)}
            >
              {t("buttons.connect")}
            </Button>
          </Flex>
        </LoadableContent>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  return {
    avatars: selectors.getAvatars(state),
    defaultAvatarId: selectors.getDefaultAvatarId(state)
  };
}

const enhance = compose(withTranslation(), connect(mapStateToProps));
export default enhance(StationCard);
